import React, { Component } from 'react';
import { Link } from "react-router-dom";

import logoSecond from '../img/logo-second.svg';
import logoMoxom from '../img/logo-moxom.svg';
import logoVoila from '../img/logo-voila.svg';


class Footer extends Component {
  render() {
    return (
      <footer className="d--flexBetween">
          <div className="d--flex">
            <Link className="mr--20" to="/">
              <img src={logoSecond} alt="NEWBINDER"/>
            </Link>
            <a className="mr--20" href="http://newbinder.pl/" target="_blank" rel="noopener noreferrer">
              <img src={logoMoxom} alt="Moxom"/>
            </a>
            <p className="p--ms color--graySix">© 2020 by Moxom. All rights reserved!</p>
          </div>
          <div>
            <a href="https://voilastudio.pl/" target="_blank" rel="noopener noreferrer" className="d--flex">
              <p className="p--ms color--graySix mr--20">web app by: </p>
              <img src={logoVoila} alt="VoilaStudio"/>
            </a>
          </div>
      </footer>
    )
  }
}

export default Footer;
